import { render, staticRenderFns } from "./TeamForm.vue?vue&type=template&id=7977534f&scoped=true"
import script from "./TeamForm.vue?vue&type=script&lang=js"
export * from "./TeamForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7977534f",
  null
  
)

export default component.exports